//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'myBottom',
  props: ['menu-index'],
  data () {
    return {
      hasMsg: false,
      todo: true,
      data: true,
      leave: true,
      source: 'v1'
    }
  },
  created () {
    this.source = localStorage.getItem('school_source') || '' // 标注版本 新版
    this.isTodoAuth()
    this.isDataAuth()
    this.isleaveAuth()
  },
  methods: {
    isleaveAuth () {
      this.$http({
        method: 'post',
        url: '/leave/isauth'
      }).then(res => {
        this.leave = res.result
      }).catch(error => {
        console.log(error)
      })
    },
    isTodoAuth () {
      this.$http({
        method: 'post',
        url: '/report/isauth'
      }).then(res => {
        this.data = res.result
      }).catch(error => {
        console.log(error)
      })
    },
    isDataAuth () {
      this.$http({
        method: 'post',
        url: '/workorder/ordertype/menu'
      }).then(res => {
        this.todo = res.result.length > 0
      }).catch(error => {
        console.log(error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/myBottom/bottom.vue